import React from 'react';
import {Anchor, Button, Icon} from '@albert-io/atomic';
import classnames from 'classnames';

interface BetaLinkProps {
  className?: string;
}

export const betaLink = 'https://airtable.com/appHlbZdSYA9CbSEu/shrYfC8lac5ljT4JQ';

const BetaFeedBackLink = ({className}: BetaLinkProps) => {
  return (
    <Button
      as={Anchor}
      href={betaLink}
      target='_blank'
      rel='noopener noreferrer'
      color='secondary'
      variant='text'
      noUnderline
      className={classnames('u-mar-r_1', className)}
      inheritColor
    >
      Beta Feedback
      <Icon className='u-mar-l_1' icon={['far', 'arrow-up-right-from-square']} />
    </Button>
  );
};

export default BetaFeedBackLink;
